// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/weather-deviation-request.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/weather-deviation-request/weather-deviation-request.js';

mount([g0]);
